
import { Log } from '@fanfanlo';
import { WebViewJs } from './WebViewJs';

function sendMessageToIframes(message:any, targetOrigin = '*') {
    // 获取页面上所有的 iframe 元素
    const iframes = document.querySelectorAll('iframe');
//   console.log('iframes=', iframes);
    // 遍历每个 iframe
    iframes.forEach(iframe => {
      try {
        // 确保 iframe 的 contentWindow 存在
        if (iframe.contentWindow) {
          // 向 iframe 发送 postMessage
          iframe.contentWindow.postMessage(message, targetOrigin);
          console.log(`向 iframe (src: ${iframe.src}) 发送消息:`, message);
        } else {
          console.warn(`iframe (src: ${iframe.src}) 的 contentWindow 不可用。`);
        }
      } catch (error) {
        console.error(`向 iframe (src: ${iframe.src}) 发送消息时发生错误:`, error);
      }
    });
    try{
        window.postMessage(message, targetOrigin);
        console.log('window message posted')
    } catch (error) {
        console.error(`向 自身 发送消息时发生错误:`, error);
      }
  }
export class AndroidListenerShell {
    log = new Log(false, this.constructor.name);
    print = this.log.print;
    listeningMap:Record<any, any> = {};
    onCallJsEventName = "onCallJsEvent"
    webview:WebViewJs;
    constructor(webview:WebViewJs) {
        this.onCallJsEventName = "onCallJsEvent"
        this.webview = webview;
    }
    init =()=>{
        if(!this.webview.isInApp)return;
        const that = this;
        (global as any)[this.onCallJsEventName] = function (event:any){
            console.log('AndroidListenerShell.init_fn.onCallJsEventName',that.onCallJsEventName, "receive message is", JSON.stringify(event))
            if(!event)return;
            // console.log('AndroidListenerShell.init_fn.onCallJsEventName listen map keys=', Object.keys(that.listeningMap))

            // console.log('AndroidListenerShell.init_fn.onCallJsEventName listen map=', that.listeningMap)
            try {
                for (const [index, value] of Object.entries(that.listeningMap)) {
                    console.log('AndroidListenerShell.init_fn.onCallJsEventName keys', value.callbackEventType, event.type)
                    console.log('value.callbackEventType !== event.type', value.callbackEventType , event.type, value.callbackEventType !== event.type)
                    if(value.callbackEventType !== event.type)continue;
                    value.fun(event.data);
                    if(value.once){
                        delete that.listeningMap[index];
                        // webViewJsListen时传入了once，所以java端自己就卸载侦听了
                        // webViewJsRemoveListen(value.target, index)
                    }
                }
                sendMessageToIframes(event, "*")
                return "ok"
            }catch (e){
                console.log('global on call js event error', e);
            }
            return 'error';
        }
    }
    listen =(target:any, type:any, callbackEventType:any, once:any, fun:any)=>{
        if(!this.webview)return -1;
        let res = this.webview.listen(target, type, callbackEventType, once);
        let index = res?.javaResultData || res;
        if(index === undefined || index === null)return -1;
        let key = index.toString();
        try{
            key = `${typeof target === 'string' ? target : 'target'}-${typeof type === 'string' ? type : 'type'}-${typeof callbackEventType === 'string' ? callbackEventType : 'callbackEventType'}-${typeof index === 'string' ? index : index.toString()}`
        }catch(e){
            console.log('listen_fn 2 error', e)
        }
        this.listeningMap[key] = {once, fun, target, type, callbackEventType}
        return key;
    }
    removeListen =(index:any)=>{
        return delete this.listeningMap[index];
    }
}